module.exports = __webpack_public_path__ + "291c59a35d45e0c75aa11cabfe91d21f.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/clever.gif
// module id = 1660
// module chunks = 0